import { SortableContainer} from 'react-sortable-hoc';
import Leaf from './Leaf';
import {arrayMoveImmutable} from 'array-move'
import { useContext } from 'react';
import { stateContext } from './ctx';
import PerfectScrollbar from 'react-perfect-scrollbar'

const SortableList = SortableContainer(({items}) => <PerfectScrollbar>
        <div className='flex flex-col gap-3'>
        {items.map((value, index) => (
            <Leaf key={`item-${index}`} index={index} value={value} idx={index} />
        ))}

        </div>
    </PerfectScrollbar>
)

const Side = () => {
    const {schema,setSchema} = useContext(stateContext)
    const printLeafs = () => {
        return schema ? schema.map(item=> {
            return {c:item.c}
        }) : []
    }
    const onSortEnd = ({oldIndex,newIndex}) => {
        const newSchema = arrayMoveImmutable(schema, oldIndex, newIndex);
        setSchema(newSchema)
    }

    return <div className='absolute top-0 right-0 w-full p-3 h-full'>
        <SortableList useDragHandle items={printLeafs()} onSortEnd={onSortEnd} />
        
    </div>
}

export default Side;